import { styled } from "@mui/material/styles";

export const ModalContainer = styled("div")(({ theme }) => ({
  width: "640px",
  position: "absolute",
  top: "50%;",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 20px 24px -4px #0A0D12",
  color: "#211F45",
  maxHeight: "700px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  "&.wider": {
    width: "850px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "90%",
  },
  "& .modal-header": {
    display: "flex",
    alignItems: "center",
    borderBottom: "#E9EAEB 2px solid",
    padding: "32px",
    gap: "20px",
    "& h2": {
      fontSize: "18px",
      fontWeight: "600",
      margin: "0",
      "& span": {
        display: "block",
        fontWeight: "normal",
        fontSize: "14px",
        color: "#666",
      },
    },
    "& .modal-icon": {
      border: "#E9EAEB 1px solid",
      padding: "12px",
      borderRadius: "12px",
      display: "flex",
    },
  },
  "& .modal-inner": {
    padding: "20px 32px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0, 
  },
  "& .close-icon": {
    position: "absolute",
    border: 0,
    background: "transparent",
    right: "32px",
    top: "32px",
    cursor: "pointer",
    "& svg": {
      width: 30,
      height: 30,
    },
  },
}));
